window.EM = window.EM || {};
window.EM.roomImages = {
  backgroundUrl: function (room) {
    if (!room) return "";
    return room.backgroundUrl || (room.backgroundImage && room.backgroundImage.url) || (room.key ? "/images/rooms/" + room.key + ".jpg" : "");
  },
  titleUrl: function (room) {
    if (!room) return "";
    return room.titleUrl || (room.titleImage && room.titleImage.url) || "";
  },
};
